import { bool, oneOf, shape, string } from 'prop-types'
import { PureComponent } from 'react'

import { PRESCRIPTION_MANAGER } from 'shared/consts/mountPoints'
import {
  DESKTOP,
  DESKTOP_ERX_MANAGER,
  DESKTOP_REBRANDING,
  MOBILE,
  MOBILE_ERX_MANAGER,
  MOBILE_REBRANDING,
  SHOP_LOGOS,
} from 'shared/consts/shopLogos'
import { withI18n } from 'shared/utils/withI18n'
import withShopAndRuntimeConfig from 'views/enhancers/withShopAndRuntimeConfig'
import { publicRuntimeConfigType, TENANTS } from 'views/utils/propTypes'

class ShopLogo extends PureComponent {
  logoImgToRender() {
    const {
      mobile,
      tenant,
      publicRuntimeConfig: {
        publicConfig: { mountPoints },
        pageProperties: { searchUrl },
      },
    } = this.props
    const isErxManager = searchUrl === mountPoints[PRESCRIPTION_MANAGER]

    const base = SHOP_LOGOS[tenant] ? SHOP_LOGOS[tenant] : SHOP_LOGOS.default
    const screen = mobile ? MOBILE : DESKTOP

    if (isErxManager) {
      const screenErxManager = mobile ? MOBILE_ERX_MANAGER : DESKTOP_ERX_MANAGER

      return base[screenErxManager] ?? base[screen]
    }

    const screenRebranding = mobile ? MOBILE_REBRANDING : DESKTOP_REBRANDING

    return base[screenRebranding] ?? base[screen]
  }

  render() {
    const {
      alt,
      publicRuntimeConfig,
      shopConfig,
      dispatch,
      i18n,
      ...imgAttrs
    } = this.props
    const logoImg = this.logoImgToRender()

    return (
      <img
        alt={alt || i18n._('header.logo.alt')}
        src={logoImg.src}
        width={logoImg.width}
        height={logoImg.height}
        {...imgAttrs}
      />
    )
  }
}

ShopLogo.propTypes = {
  tenant: oneOf(TENANTS).isRequired,
  mobile: bool,
  alt: string.isRequired,
  publicRuntimeConfig: shape(publicRuntimeConfigType),
  shopConfig: shape(Object),
  dispatch: shape(Object),
  i18n: shape(Object),
}

ShopLogo.defaultProps = {
  mobile: false,
  publicRuntimeConfig: {},
  shopConfig: {},
  dispatch: {},
}

export default withI18n()(withShopAndRuntimeConfig(ShopLogo))
